import {Component, Input, OnInit} from '@angular/core';
import { FIELD_MANDATORY_ERROR } from '../../../core/constants/validation-error-strings.constants';
import {AbstractControl, UntypedFormGroup, Validators} from '@angular/forms';
import {
  FULL_PASSWORD_REGEXP,
  PASSWORD_NUMBER_REGEXP,
  PASSWORD_UPPERCASE_REGEXP
} from '../../../core/constants/validatation-regex.constants';
import {MIN_PASSWORD_LENGTH} from '../../../core/constants/length.constansts';

export const PASSWORD_VALIDATION = [
  Validators.required,
  Validators.pattern(FULL_PASSWORD_REGEXP),
  Validators.pattern(PASSWORD_UPPERCASE_REGEXP),
  Validators.pattern(PASSWORD_NUMBER_REGEXP),
  Validators.minLength(MIN_PASSWORD_LENGTH)
];

@Component({
  selector: 'app-password-input-with-validation',
  templateUrl: './password-input-with-validation.component.html',
  styleUrls: ['./password-input-with-validation.component.scss']
})
export class PasswordInputWithValidationComponent implements OnInit {

  @Input() password: AbstractControl;
  @Input() form: UntypedFormGroup;

  readonly FIELD_MANDATORY_ERROR: string = FIELD_MANDATORY_ERROR;

  get hasUppercaseLetterInString(): boolean {
    return PASSWORD_UPPERCASE_REGEXP.test(this.password?.value);
  }

  get hasNumberInString(): boolean {
    return PASSWORD_NUMBER_REGEXP.test(this.password?.value);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
